import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Token } from 'html2canvas/dist/types/css/syntax/tokenizer';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import {
  catchError,
  filter,
  finalize,
  map,
  switchMap,
  take,
} from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthGuard } from './auth.guard';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService {
  private refreshTokenInProgress = false;
  private refreshTokenSubject = new BehaviorSubject<boolean | null>(null);

  constructor(private http: HttpClient, private authGuard: AuthGuard) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    req = this.repeatRequest(req);

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (this.refreshTokenInProgress) {
            return this.refreshTokenSubject.pipe(
              filter((result) => result !== null),
              take(1),
              switchMap(() => next.handle(this.repeatRequest(req)))
            );
          } else {
            this.refreshTokenInProgress = true;
            this.refreshTokenSubject.next(null);
            return this.refreshToken().pipe(
              switchMap(() => {
                this.refreshTokenSubject.next(true);
                return next.handle(this.repeatRequest(req));
              }),
              finalize(() => (this.refreshTokenInProgress = false))
            );
          }
        } else {
          if (error.status === 404) {
            if (error.error?.message) {
              return throwError(error);
            }
            //console.log(localStorage.getItem('access_token'));
            return of(null);
          } else {
            return throwError(() => {});
          }
        }
      })
    );
  }

  private refreshToken() {
    const url =
      'https://www.strava.com/api/v3/oauth/token' +
      '?client_id=' +
      environment.stravaClientId +
      '&client_secret=' +
      environment.stravaSecret +
      '&refresh_token=' +
      localStorage.getItem('refresh_token') +
      '&grant_type=refresh_token';
    //console.log('here');
    return this.http.post<Token>(url, {}).pipe(
      map((token: any) => {
        localStorage.setItem('access_token', token.access_token);
        localStorage.setItem('refresh_token', token.refresh_token);
        localStorage.setItem('expires_at', token.expires_at.toString());
      })
    );
  }

  private repeatRequest(request: HttpRequest<any>): HttpRequest<any> {
    if (request.url.includes('strava')) {
      const token = localStorage.getItem('access_token');
      return request.clone({
        headers: request.headers.set('Authorization', 'Bearer ' + token),
      });
    }
    return request;
  }
}
